@if (compact()) {
  <button mat-icon-button
          class="cp-trigger-compact"
          [matMenuTriggerFor]="pickerMenu"
          [disabled]="!hasAvailableTypes()"
          aria-label="Add constraint">
    <mat-icon>add</mat-icon>
  </button>
} @else {
  <button mat-flat-button
          class="cp-trigger"
          [matMenuTriggerFor]="pickerMenu"
          [disabled]="!hasAvailableTypes()">
    <mat-icon>add</mat-icon>
    {{ 'policyBuilder.addConstraint' | transloco }}
  </button>
}

<mat-menu #pickerMenu="matMenu" class="cp-menu" xPosition="after">
  @for (category of categories; track category.id) {
    <div class="cp-category-header">
      <mat-icon class="cp-category-icon">{{ category.icon }}</mat-icon>
      <span class="cp-category-label">{{ category.labelKey | transloco }}</span>
    </div>
    @for (opt of category.types; track opt.type) {
      <button mat-menu-item
              class="cp-item"
              [class.cp-item--disabled]="isDisabled(opt.type)"
              [disabled]="isDisabled(opt.type)"
              (click)="select(opt.type)">
        <mat-icon class="cp-item-icon" [class]="'cp-item-icon--' + opt.category">
          {{ opt.icon }}
        </mat-icon>
        <div class="cp-item-text">
          <span class="cp-item-label">{{ opt.labelKey | transloco }}</span>
          <span class="cp-item-desc">{{ opt.descriptionKey | transloco }}</span>
        </div>
      </button>
    }
  }
</mat-menu>
